import { Material } from 'src/api/endpoints/materials'
import { Nullable } from 'primereact/ts-helpers'
import { getServerPath } from 'src/http'
import { ResponseError } from 'src/api'
import { v4 as uuidV4 } from 'uuid'

export const downloadFile = async (endpoint: string): Promise<void> => {
    const headers = new Headers()
    const accessToken = localStorage.getItem('access-token')
    
    if (!accessToken) {
        localStorage.removeItem('userId')
        localStorage.removeItem('access-token')
        localStorage.removeItem('refresh-token')
        
        return window.location.replace('/login')
    }
    
    headers.set('Authorization', accessToken)
    headers.set('X-Correlation-Id', uuidV4())
    
    const response: Response = await fetch(getServerPath() + endpoint, {
        headers,
    })
    
    if (!response.ok) {
        const responseData: any = await response.json()
        const correlationId: string | null = response.headers.get('x-correlation-id')
        
        if (correlationId)
            console.warn(`CorrelationID: ${correlationId}`)
        
        throw {
            status: response.status,
            message: responseData.message,
            correlationId: correlationId,
        } as ResponseError
    }
    
    const blob: Blob = await response.blob()
    
    const fileUrl: string = window.URL.createObjectURL(blob)
    
    const fileDownloadAnchor: HTMLAnchorElement = document.createElement('a')
    fileDownloadAnchor.href = fileUrl
    
    const parsedFilename: string | null =
        getFileName(response.headers.get('content-disposition'))
    
    if (parsedFilename) {
        fileDownloadAnchor.setAttribute(
            'download',
            parsedFilename,
        )
    }
    
    document.body.appendChild(fileDownloadAnchor)
    fileDownloadAnchor.click()
    
    document.body.removeChild(fileDownloadAnchor)
    window.URL.revokeObjectURL(fileUrl)
}

function getFileName(disposition: Nullable<string>): string | null {
    const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i
    const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i
    
    if (!disposition) return null
    
    let fileName: string | null = null
    
    if (utf8FilenameRegex.test(disposition)) {
        fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)?.at(1) ?? '')
        return fileName
    }
    
    const filenameStart: number = disposition.toLowerCase().indexOf('filename=')
    
    if (filenameStart >= 0) {
        const partialDisposition: string = disposition.slice(filenameStart)
        const matches: RegExpExecArray | null = asciiFilenameRegex.exec(partialDisposition)
        
        if (matches != null && matches[2]) {
            fileName = matches[2]
        }
    }
    
    return fileName
}

export const downloadMaterialSegment = (material: Material, segment: 'lesson' | 'homework' | 'practice' | 'presentation') => {
    return downloadFile(`/subjects/${material.subject.id}/materials/${material.id}/${segment}/download`)
}